import { request as http } from '@/utils/http'
import type {
  SalesQueryContext,
  PageResponse,
  PriceLclPageRequest,
  PriceLclListVO,
  PriceLclVO
} from './types'

// 分页查询拼箱运价
export const page = (params: PriceLclPageRequest) => {
  return http.post<PageResponse<PriceLclListVO>>('/price/query/lcl/page', params)
}

// 获取拼箱运价详情
export const get = (id: string, context: SalesQueryContext = {}) => {
  return http.post<PriceLclVO>('/price/query/lcl/get', { ...context, id })
}
